<template>
  <div id="app" v-cloak>
    <salary-header></salary-header>
    <ContractDialog ref="comContract" :show="false" :isSuccess="false"></ContractDialog>
  </div>
</template>

<script>
import Header from "./components/Header";
import ContractDialog from '@/components/DialogBox/index.vue';
import { conStatusHandle } from "@/assets/js/common";
import Vue from "vue";

export default {
  name: "App",
  created() {
    Vue.prototype.$isOpenDialogRz = this.isOpenDialogRz;
  },
  components: {
    "salary-header": Header, //注册Header组件
    ContractDialog
  },
  methods:{
    async isOpenDialogRz(fun,val) {
      let isShow=await this.openDialogRz();
      if(isShow) return
      fun(val)
    },
    openDialogRz(){
      return new Promise(async (resolve, reject) => {
        let com = this.$refs.comContract;
        const boundFunction = conStatusHandle.bind(com);
        let value=await boundFunction();
        resolve(value)
      })
    },
  }
}
</script>

<style>

  [v-cloak]{
    display: none!important;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue